export default __webpack_public_path__ + "static/media/commandes.30247070.png";